import { useState } from "react";

type Props = {
  value: string;
  label?: string;
  className?: string;
  title?: string;
};

export default function CopyButton({ value, label, className = "", title }: Props) {
  const [state, setState] = useState<"idle" | "ok" | "fail">("idle");

  async function copy(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(value);
      setState("ok");
    } catch {
      setState("fail");
    }
    setTimeout(() => setState("idle"), 1200);
  }

  return (
    <button
      type="button"
      onClick={copy}
      title={title ?? `Copy "${value}"`}
      aria-label={`Copy ${value}`}
      className={`inline-flex items-center gap-1 text-[11px] text-slate-500 hover:text-brand-700 align-middle ${className}`}
    >
      <span aria-hidden="true">{state === "ok" ? "✓" : state === "fail" ? "×" : "⧉"}</span>
      {label && <span>{label}</span>}
      {state === "ok" && <span className="text-emerald-600">copied</span>}
      {state === "fail" && <span className="text-red-600">failed</span>}
    </button>
  );
}
